import { useEffect } from "react";
import posthog from "../utils/posthog";

export default function usePosthogPageview() {
	useEffect(() => {
		posthog.capture("$pageview");
	}, []);
}
